export const PeriodToggle = ({ value, onChange, testid }) => (
    <div className="inline-flex rounded-full border border-white/10 bg-black/40 p-0.5" data-testid={testid}>
        {[['today', 'Today'], ['7d', 'Last 7 days']].map(([v, label]) => (
            <button key={v} type="button" onClick={() => onChange(v)} data-testid={`${testid}-${v}`}
                className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${value === v ? 'bg-white text-black' : 'text-zinc-400 hover:text-white'}`}>
                {label}
            </button>
        ))}
    </div>
);
